const mediaMimePattern = /^(image|audio|video)\//

export function normalizeAttachmentForPreview(attachment) {
  if (!attachment || typeof attachment !== 'object') return attachment
  if (attachment.pathmedia?.path || attachment.pathdoc?.path || attachment.forge_file?.translated) {
    return attachment
  }
  if (!attachment.url || !attachment.mime_type) return attachment

  if (mediaMimePattern.test(attachment.mime_type)) {
    return { ...attachment, pathmedia: { path: attachment.url } }
  }

  return { ...attachment, pathdoc: { path: attachment.url } }
}

export function toMediaViewerItem(attachment) {
  const normalized = normalizeAttachmentForPreview(attachment)
  if (!normalized?.pathmedia?.path) return null

  return {
    src: normalized.pathmedia.path,
    downloadable_url: normalized.downloadable_url || normalized.url || normalized.pathmedia.path,
    mime_type: normalized.mime_type,
    ext: normalized.ext,
    size: normalized.size,
    name: normalized.name,
    uid: normalized.uid,
    autoplay: true,
    item: attachment
  }
}
